<div class="filter"
     [class.filter-open]="FilterOpen"
>
    <div class="filter-options">
        <h3>Branche</h3>
        <mat-form-field>
            <mat-select placeholder="Branche" [(value)]="CustomerTypeFilter"
                        multiple [disabled]="!FilterOpen" >

                <mat-select-trigger>
                    {{CustomerTypeFilter.length
                    ? (CustomerTypeFilter.length > 1
                        ? CustomerTypeFilter.length + ' Branche'
                        : CustomerTypeFilter[0].Name)
                    : ''}}
                </mat-select-trigger>

                <button app-button class="mat-option" (click)="CustomerTypeToggleFilterArraysEmpty()" [Disabled]="!FilterOpen"
                            [Inverted]="true">'alles ' + (!CustomerTypeFilter.length ? 'auswählen' : 'abwählen')</button>

                <mat-option [value]="customerType" *ngFor="let customerType of CustomerTypes$ | async">{{customerType.Name}}
                </mat-option>

            </mat-select>
        </mat-form-field>
    </div>

    <div class="button-container">
        <button app-button (click)="ResetFilter()">Zurücksetzen</button>
        <button app-button (click)="Filter()">Anwenden</button>
    </div>
</div>
